'use strict';

app.controller("previewJobProfileController", ['$scope', 'hUser', '$window', '$stateParams', 'previewJobPostService', 'DispatcherServices', '$compile', '$filter', 'appLayoutViewService', "localize", "$state", "hEvent", "JobDetailsBus",
    function ($scope, hUser, $window, $stateParams, previewJobPostService, DispatcherServices, $compile, $filter, appLayoutViewService, localize, $state, hEvent, JobDetailsBus) {

        var templateEng = DispatcherServices.getNunjucks();
        var slideIndex = 0;
        var slideInterval;
        $scope.languages = [
            {id: 'en', label: 'EN'},
            {id: 'fr', label: 'FR'},
            {id: 'es', label: 'ES'}];

        $scope.slide = function (value) {
            clearTimeout(slideInterval);
            slideIndex += value;
            var slides = $(".carousel-slides");

            if (slides.length) {
                slideInterval = setTimeout(function () {
                    $scope.slide(1);
                }, 4000);
                if (slideIndex < 0) {
                    slideIndex = slides.length - 1;
                } else if (slideIndex === slides.length) {
                    slideIndex = 0;
                }
                for (var i = 0; i < slides.length; i++) {
                    slides[i].style.display = 'none';
                }
                slides[slideIndex].style.display = 'block';
            }
        };

        $scope.slide(0);

        //bind logged-in variable
        $scope.isEmployer = hUser && hUser.data && hUser.data.user && hUser.data.user.user_employer;
        $scope.onReachMap = function (){
            var job = $scope.data.data.job;
            var theme = appLayoutViewService.getBrandTheme();
            var markerColor = theme.scheme_settings && theme.scheme_settings.accent_color;
            var jobLocationsStaticMap = [];
            for (var i = 0; i < job.JobLocation.length; i++) {
                jobLocationsStaticMap.push([""]);
                jobLocationsStaticMap[i].push(job.JobLocation[i].Location.latitude);
                jobLocationsStaticMap[i].push(job.JobLocation[i].Location.longitude);
            }
            var unsignedURL = $filter('googleStaticMap')({locations: jobLocationsStaticMap, color: markerColor});
            GatewayAPI.signGoogleStaticMapsURL(unsignedURL).then(function (resp) {
                $scope.signedStaticMap = resp.signed_url;
            }, function (err) {
                console.error(err);
            }).finally(function () {
                $scope.$evalAsync();
            });
        };
        $scope.$watch(function () {
            return hUser && hUser.data && hUser.data.user && hUser.data.user.user_employer;
        }, function (newVal, oldVal) {
            $scope.isEmployer = newVal;
        });

        var init = function () {
            $scope.defaultLang =  localize.getLang();
            $scope.currentLang =  localize.getLang();
            var defer = $q.defer();
            var promises = {};

            promises['basicInfo'] = CareerPortalAPI.getBrandBasicInfo(previewJobPostService.getPreviewBrandId());
            promises['previewDetails'] = previewJobPostService.getPreviewJobDetails()


            $q.all(promises).then(function (res) {
                    $scope.data = parseData(res['previewDetails']);
                    $scope.data.data.basicInfo = res['basicInfo'];
                    $scope.data.hUser = hUser.data.user;
                    $scope.data.isLoggedIn = hUser.isLoggedIn();
                    var dynamicTitle = getDynamicPageTitle(res['previewDetails']);
                    var pageTitle = 'Preview: ' + dynamicTitle;
                    $window.document.title = pageTitle;
                    var renderedHtml = templateEng.render("../modules/job_profile/views/job-details.tmpl.html", $scope.data);
                    var dataWrapper = '.job-post-profile-container';
                    $(dataWrapper).append($compile(renderedHtml)($scope));
                    var profileImage;
                    if ($scope.data.data.brand.BrandMedia) {
                        profileImage = _.findWhere($scope.data.data.brand.BrandMedia, {'type': 'profile_image'});
                    }

                    if ($scope.data.data.brand.scheme_settings) {
                        let bannerColor = ($scope.data.data.brand.scheme_settings?.career_portal_banner_color || $scope.data.data.brand.scheme_settings?.accent_color || '#0088DD');
                        document.documentElement.style.setProperty('--career_portal_banner', bannerColor);
                    } else {
                        document.documentElement.style.setProperty('--career_portal_banner', '#0088DD');
                    }

                    appLayoutViewService.updateBrandTheme({
                        scheme_settings: $scope.data.data.brand.scheme_settings,
                        profile_image: profileImage || null
                    }, 'preview_job_page_theme')
                        .finally(function () {
                            $scope.$evalAsync();

                            if ($(window).width() <= 575) {
                                $('.job-header').addClass('active');
                                $('.fixed-header-mobile').removeClass('active');
                                $('.header-bar-mobile .job-arrangements-box').css('visibility', 'visible');
                            } else {
                                $('.job-header').removeClass('active');
                                $('.fixed-header-mobile').addClass('active');
                                $('.header-bar-mobile .job-arrangements-box').css('visibility', 'hidden');
                            }
                        });
                });
            return defer.promise;
        }

        var getDynamicPageTitle = function (data) {
            var title = '';
            if (data.job.alias_position) {
                title += data.job.alias_position;
            } else {
                title += data.job.Position.name;
            }
            title += ' at ';
            if (data.brand.external_business_name) {
                title += data.brand.external_business_name;
            } else {
                title += data.brand.name;
            }

            return title;
        }

        $scope.showShareList = function () {
            $scope.isSharedListOpened = !$scope.isSharedListOpened;
        };

        $scope.getUrlSocialMedia = function (source) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        };


        $scope.changeLanguage = function (languageCode) {
            let toLang = languageCode || $scope.defaultLang;

            HStorageManager.put({
                storageLevel: HStorageManager.StorageLevels.COOKIES,
                key: 'lang',
                value: toLang,
                codec: false,
                expiryDays: 30
            });

            hEvent.track(
                "language_change",
                {
                    "to": toLang,
                    "from": $scope.currentLang,
                    "page": $state.current.name
                },
                async function () {

                    if (hUser.isLoggedIn()) {

                        await SettingsAPI.saveUserLocale(toLang);
                        hRedirect(hGetCurrentUrl(toLang));

                    } else {
                        hRedirect(hGetCurrentUrl(toLang));
                    }
                });
        };

        var parseData = function (resultData) {
            var mergedData = {};
            var position = "";
            var brand = resultData.brand || {};
            var job = resultData.job || {};
            mergedData.data = resultData;
            mergedData.data.source = 'PREVIEW';
            if (brand.BrandMedia) {
                for (var i in brand.BrandMedia) {
                    if (brand.BrandMedia[i].type === 'job_background_image') {
                        brand.job_cover = brand.BrandMedia[i];
                    }

                    if (brand.BrandMedia[i].type === 'background_image') {
                        brand.background_image = brand.BrandMedia[i];
                    }

                    if (brand.BrandMedia[i].type === 'profile_image') {
                        brand.profile_image = brand.BrandMedia[i];
                    }
                }
            }

            if (brand.force_media) {
                brand.forced_media = {};

                for (var i in brand.force_media) {
                    brand.force_media[i].path = brand.force_media[i].path || "";
                    brand.force_media[i].brand_id = brand.force_media[i].path.split("/")[1];
                    brand.forced_media[brand.force_media[i].type] = brand.force_media[i];
                }

                if (brand.forced_media['job_background_image']) {
                    brand.job_cover = brand.forced_media['job_background_image'];
                }
            }

            if (brand.Location && brand.Location.length) {
                mergedData.data.brand.BrandLocations = publicConfiguration.functions.locationFormatter(brand.Location);
            }

            if (brand.slug && job.Position) {
                position = job.alias_position != undefined ? job.alias_position : job.Position.name;
                mergedData.data.job.id = job.id;
                mergedData.data.job.position = position;
            }
            mergedData.data.visibility = getVisibilityForJPLP();

            mergedData.data.logjam_settings = brand.logjam_settings || {};
            if (typeof (getParameterByName) !== "undefined") {
                var utm_source = getParameterByName("utm_source");
                mergedData.data.utm_source = utm_source.toLowerCase();
                if (mergedData.data.utm_source == "simply") {
                    mergedData.data.utm_source = "simplyhired";
                }
                var viewOnly = getParameterByName('view_only');
                var h_apply_flow = getParameterByName('h_apply_flow');
                mergedData.data.viewOnly = viewOnly && (viewOnly.toLowerCase() === 'true');
                mergedData.data.h_apply_flow = h_apply_flow && (h_apply_flow.toLowerCase() === 'true');
            }

            if ($window.location.pathname.indexOf("/internal") === 0) {
                if (['PRIVATE', 'BOTH'].indexOf(job.access_mode) > -1) {
                    job.description = job.private_description || job.description;
                }
            }

            if (mergedData.data.brand && mergedData.data.brand.Location) {
                var locations = mergedData.data.brand.Location;

                for (var i in locations) {
                    var country = locations[i].Country || {};

                    if (country['code'] == 'UK') {
                        mergedData.data.currentCounrty = 'UK';
                    }
                }
            }

            if (mergedData.data.job.end_date) {
                mergedData.data.job.end_date = moment(mergedData.data.job.end_date).format('ddd, DD MMM YYYY');
            }

            if (mergedData.data.job.estimated_start_date) {
                mergedData.data.job.estimated_start_date = moment(mergedData.data.job.estimated_start_date).format('ddd, DD MMM YYYY');
            }

            if (mergedData.data.job.start_date) {
                mergedData.data.job.start_date = moment(mergedData.data.job.start_date).format('ddd, DD MMM YYYY');
            }

            mergedData.data.tenantJobsServiceEnabled = (mergedData.data.brand.public_services && mergedData.data.brand.public_services.indexOf('TENANT_JOBS') > -1);
            mergedData.data.selected_job_post_type = previewJobPostService.getPreviewSelectedJobPostType();
            mergedData.data.postType = previewJobPostService.getPostType();
            mergedData.data.is_owner = true;
            return mergedData;
        }

        $scope.toggleSkills = function (){
            $scope.data.visibility.skills.collapsed = !$scope.data.visibility.skills.collapsed;
        }

        $scope.toggleDetails = function (){
            $scope.data.visibility.details.collapsed = !$scope.data.visibility.details.collapsed;
        }

        $scope.descriptionToggle = function(){
            $scope.descriptionCollapsed = !$scope.descriptionCollapsed;
        }

        $scope.onSearchOpen = function (isShown) {
            $scope.searchOpen = isShown;
            $scope.$evalAsync();
        };

        $scope.isSideBarExpanded = function () {
            return appLayoutViewService.isSideBarExpanded();
        };

        $scope.getToggleSource = function () {
            return appLayoutViewService.getToggleSource();
        };

        $scope.ctrlObject = {};
        $scope.collapseTextToggled = function () {
            $timeout(function () {
                $scope.ctrlObject.updateStickyLine();
            },0);
        }

        init();

        $(window).scroll(JobDetailsBus.handleJobPageScroll);
    }]);